module.exports = __webpack_public_path__ + "static/media/nav-icon-readiness-zone-active.591fbb14.svg";